import { render, staticRenderFns } from "./UiHeaderUserSettings.vue?vue&type=template&id=793df303&"
import script from "./UiHeaderUserSettings.vue?vue&type=script&lang=js&"
export * from "./UiHeaderUserSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports